import { configureStore } from "@reduxjs/toolkit";
import websiteReducer from '../slices/websiteSlice';
import templateReducer from '../slices/templateSlice';
export const store = configureStore({
    reducer: {
        websites: websiteReducer,
        //templates: templateReducer, // full fledged
        templates: templateReducer, // temporary
    }
})